exports = module.exports = require("./../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".DateNode{position:relative;height:4rem}.DateNode .date{background-color:#8e9ab2;border-radius:.3rem;font-family:Roboto,sans-serif;border:.25rem solid #f2f2f2;width:5.5rem;border-radius:.5rem;margin:0;color:#fff;font-size:.8rem;line-height:1.4rem;text-align:center;margin-top:-0.95rem;background:#fff;color:#666;margin:0 auto}@media screen and (min-width:480px){.DateNode .date{position:absolute;top:50%;left:calc(92% - 2.75rem - .25rem)}}@media screen and (min-width:768px){.DateNode .date{left:calc(50% - 2.75rem - .25rem)}}.DateNode.first .date{top:auto;bottom:0}.DateNode .horizontal-line{position:absolute;top:0;width:.25rem;height:100%;background-color:#8e9ab2;content:\" \";left:calc(92% - .125rem);display:none}@media screen and (min-width:480px){.DateNode .horizontal-line{display:block}}@media screen and (min-width:768px){.DateNode .horizontal-line{left:calc(50% - .125rem)}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./src/Components/Timeline/DateNode.scss
// module id = 228
// module chunks = 0